import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent {
  showDropDown = false;
  dropdownList: { name: string; isChecked: boolean }[];
  totalCheckedAmount = 0;
  isSelectAll = false;

  @Input() set childObj(v: { name: string; isChecked: boolean }[]) {
    this.dropdownList = v;
    this.totalCheckedAmount = this.dropdownList.reduce((acc, item: any) => (item.isChecked ? ++acc : acc), 0);
    this.isSelectAll = this.totalCheckedAmount === this.dropdownList.length ? true : false;
  }
  @Input() disabled = false;
  @Output() passSelect = new EventEmitter();
  @ViewChild('multiselectDropdown') multiselectDropdown;

  isOptionChecked(index, status) {
    this.dropdownList[index]['isChecked'] = status;
    this.passSelect.emit([...this.dropdownList]);
    const calculate = status ? 1 : -1;
    this.totalCheckedAmount += calculate;
    // check whether selectAll:
    const booleanArr = [];
    this.dropdownList.forEach((eachList) => booleanArr.push(eachList.isChecked));
    const hasSelectedAll = !booleanArr.includes(false);
    hasSelectedAll ? this.selectAll(hasSelectedAll) : (this.isSelectAll = false);
  }

  selectAll(status) {
    this.isSelectAll = status;
    if (status) {
      // 1, make all as true;
      this.dropdownList.forEach((item) => {
        item.isChecked = true;
      });
      //2, emit list back
      this.passSelect.emit([...this.dropdownList]);
      //3, selectedAmount = all length
      this.totalCheckedAmount = this.dropdownList.length;
    } else {
      // 1, make all as false;
      this.dropdownList.forEach((item) => {
        item.isChecked = false;
      });
      //2, emit list back
      this.passSelect.emit([...this.dropdownList]);
      //3, selectedAmount = 0
      this.totalCheckedAmount = 0;
    }
  }

  @HostListener('document:click', ['$event'])
  clickedOut(event) {
    if (!this.multiselectDropdown?.nativeElement?.contains(event.target)) {
      this.showDropDown = false;
    }
  }

  public reset(): void {
    this.selectAll(false);
  }
}
